import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

const faqs = [
  {
    question: 'Who is Limitly for?',
    answer: 'Limitly is designed for freelancers, agencies, and small businesses (2-50 employees) who need better control over team spending. Whether you\'re managing contractors, tracking project expenses, or keeping operational costs under control, Limitly gives you the tools to manage spend without enterprise complexity.'
  },
  {
    question: 'What activities are blocked or restricted?',
    answer: 'To ensure compliance and reduce fraud risk, certain high-risk and cash-like activities are restricted on Limitly cards. Blocked categories include: cryptocurrency exchanges and on-ramps, gambling and casinos, adult entertainment, firearms and ammunition, narcotics and CBD products, money transfer services and peer-to-peer payments, gift cards and prepaid reloads, and certain high-risk digital goods. You maintain full control through per-card spending limits (daily/weekly/monthly), merchant category (MCC) allow/block lists, specific merchant allow/block rules, instant freeze/unfreeze capabilities, receipt requirements with admin review, and a complete audit log of all actions.'
  },
  {
    question: 'Is this a bank account?',
    answer: 'No, Limitly is not a bank account. We provide a spend management platform with card controls and vendor payment capabilities. Financial services (card issuance, payment processing) are provided by our regulated financial institution partners. Limitly is the software layer that gives you control and visibility.'
  },
  {
    question: 'How do team cards work?',
    answer: 'You can issue virtual or physical cards to team members with custom roles and spending limits. Each card can have its own budget, merchant restrictions, and category controls. Admins set the rules, and the system enforces them automatically—preventing unauthorized spending before it happens.'
  },
  {
    question: 'How do vendor transfers work?',
    answer: 'Limitly allows you to pay vendors and contractors directly from your account with transaction references and notes. Each payment is logged with full details for reconciliation. Availability and supported regions vary—join the waitlist to learn about availability in your area.'
  },
  {
    question: 'What receipts and exports are supported?',
    answer: 'You can capture receipts via photo upload or email forwarding. All transactions can be exported to CSV with receipts, notes, and categorization included. Accounting integrations (QuickBooks, Xero) are on the roadmap—join the waitlist to stay updated.'
  },
  {
    question: 'Do you support international businesses?',
    answer: 'We\'re starting with select regions and expanding gradually. Multi-currency support and international vendor payments are in development. Join our waitlist to be notified when Limitly becomes available in your country.'
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 md:py-32 relative bg-white/[0.02]">
      <div className="container mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold heading-font text-white">
            Frequently asked questions
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Have questions? We have answers.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white/5 rounded-xl border border-white/10 backdrop-blur-sm overflow-hidden transition-all hover:border-white/20"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left transition-colors hover:bg-white/5"
              >
                <span className="text-lg font-semibold text-white pr-8">
                  {faq.question}
                </span>
                <ChevronDown
                  size={20}
                  className={`text-gray-400 flex-shrink-0 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 text-gray-400 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
